import {
  Button,
  Form,
  Modal,
  Row,
  Space,
  Spin,
} from "../../common/utils/antd-imports/AntdImports";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import "./NotifyModel.css";
import { useDispatch, useSelector } from "react-redux";
import { productExpiryNotify } from "../../../store/thunks/buyer-thunks/BuyerThunks";
import FormItem from "antd/es/form/FormItem";

const NotifyModel = ({ openNotify, setNotify, product }) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.products);
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };

  const handleNotifyApi = (values) => {
    const user = JSON.parse(localStorage.getItem("user"))?.user;
    const payload = {
      loggedinUser: {
        clientId: null,
        email: user?.email,
        firstName: user?.firstName,
        lastName: user?.lastName,
        user_id: user?.user_id,
        user_role: user?.user_role,
        user_type: user?.user_type,
      },
      product_id: product?.id,
      user_message: values?.user_message,
    };
    dispatch(productExpiryNotify(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        setNotify(false);
        form.resetFields();
      }
    });
  };

  return (
    <>
      <div>
        <Row>
          <span>
            <span className="gross-fee-text" style={{ marginRight: "0.5rem" }}>
              Notify Me
            </span>
            <span style={{ fontSize: "16px" }}>for product</span>
            <span className="gross-fee-text" style={{ marginLeft: "0.5rem" }}>
              {product?.title}
            </span>
          </span>
        </Row>
        <Space direction="vertical" size={15} className="notify-modal-space">
          <Form form={form} onFinish={handleNotifyApi}>
            <Row>
              <FormItem
                style={{ width: "100%" }}
                name="user_message"
                rules={[
                  {
                    required: true,
                    message: "Message is required!",
                  },
                ]}
              >
                <FloatingTextArea
                  customStyles={textAreaFloatingInputStyles}
                  maxLength={500}
                  label={<>{`Message`}</>}
                  className="billboard-input-feild billboard-text-area"
                />
              </FormItem>
            </Row>

            <Row justify="end">
              <Space size={10}>
                <div className="billboard-buttons-div ">
                  <Button
                    className="billboard-buttons billboard-button-1"
                    onClick={() => {
                      form.resetFields();
                      setNotify(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="billboard-buttons billboard-button-2"
                    onClick={() => {
                      form.submit();
                    }}
                  >
                    Notify Me
                  </Button>
                </div>
              </Space>
            </Row>
          </Form>
        </Space>
      </div>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default NotifyModel;
